<ng-container *ngIf="newsFeedResponse.length > 0">
    <cc-news-feed-v2-container [newsFeeedItems]="newsFeedResponse" [attributes]="newsFeedAttributes" [lobbyType]="lobbyType" [data]="data">
    </cc-news-feed-v2-container>
</ng-container>
